module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_6-052841f6ccf642a08a095a41d53f67bc.jpg";